import React, {useEffect, useRef} from "react";
import style from "./backgroundVideo.module.css"

export function BackgroundVideo({src, loadingImage, loadFullyBeforePlaying = false, background_color, muted = true,  controls = false, loop = true, onReadyToPlay, onPlay}) {
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (loadFullyBeforePlaying) {
            console.log("loading video", src);
            try {
                fetch(src).then(response => response.blob()).then(blob => {
                    video.src = window.URL.createObjectURL(blob);
                }).then(() => {
                    onReadyToPlay?.(video);
                }).then(() => {
                    video.play();
                });

            } catch (error) {
                console.error(error);
            }
        }
        else {
            try {
                const videoRequest = new Request(src);
                fetch(videoRequest).then(() => {
                    video.src = src;
                }).then(() => {
                    onReadyToPlay?.(video);
                }).then(() => {
                    video.play();
                })
            } catch (error) {
                console.error(error);
            }
        }      
    }, []);
    
    return (
        <>
            <div className={style.background_video_container}
                 style={{
                     width: "100%",
                     height: "100%",
                     backgroundColor: background_color ??  null,
                 }}
            >
                <video
                    poster={loadingImage}
                    ref={videoRef}
                    className={style.background_video}
                    src={src}
                    loop={loop}
                    muted={muted}
                    controls={controls}
                    onContextMenu={(evt) => evt.preventDefault()} // prevents right clicks
                >
                    <source src='' type="video/mp4"/>
                </video>

            </div>
        </>
    )
}